import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import {
  FormControl,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";
import { ReactComponent as UnCheckedIcon } from "../../assets/images/uncheck-icon.svg";
import { ReactComponent as CheckedIcon } from "../../assets/images/checked-icon.svg";

const CFormRadioGroup = ({
  name,
  label,
  options = [],
  row = false,
  disabled = false,
  className = "",
  helperText = "",
  ...other
}) => {
  const { control, formState: { errors } } = useFormContext();
  const error = errors[name];

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl 
          className={`custom-form-select w-full ${className}`}
          error={!!error} 
          disabled={disabled}
          fullWidth
        >
          {label && (
            <div className="flex items-center gap-2 mb-1">
              <InputLabel
                id={name}
                shrink={field.value !== undefined && field.value !== null}
                className="!mb-0"
              >
                {label}
              </InputLabel>
            </div>
          )}
          <div 
            className="2xl:!h-[50px] !h-[45px] flex items-center"
            style={{ minHeight: '50px' }}
          >
            <RadioGroup
              row={row}
              value={
                field.value !== undefined && field.value !== null
                  ? String(field.value)
                  : ""
              }
              onChange={(e) => {
                const value = e.target.value;
                // Convert string values to appropriate types based on option values
                const selectedOption = options.find(
                  (opt) => String(opt.value) === value
                );
                if (selectedOption) {
                  field.onChange(selectedOption.value);
                }
              }}
              sx={{
                margin: 0,
                padding: 0,
                '& .MuiFormControlLabel-root': {
                  marginRight: '24px',
                  marginTop: 0,
                  marginBottom: 0,
                }
              }}
              {...other}
            >
              {options.map((option) => (
                <FormControlLabel
                  key={String(option.value)}
                  value={String(option.value)}
                  control={
                    <Radio 
                      icon={<UnCheckedIcon />} 
                      checkedIcon={<CheckedIcon />}
                      disabled={disabled}
                      sx={{
                        padding: '6px 12px',
                        '& .MuiSvgIcon-root': {
                          fontSize: '24px',
                          width: '24px',
                          height: '24px',
                        }
                      }}
                    />
                  }
                  label={
                    <span className="!text-gray-700 !font-[Poppins]" style={{ fontSize: '16px', lineHeight: '24px' }}>
                      {option.label}
                    </span>
                  }
                />
              ))}
            </RadioGroup>
          </div>
          {(!!error || helperText) && (
            <FormHelperText error={!!error} sx={{ ml: 0, mt: 0.5 }}>
              {error ? error.message : helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default CFormRadioGroup;

